import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsPE: CultureInfo = {
  name: 'es-PE',
  displayName: 'Spanish (Peru)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-PE',
  parent: CultureInfoEs
};
